// import React, { useState } from "react";
// import TownPlanningSidebar from "../components/TownPlanningSidebar";
// import styles from "../styles/TownPlanningDashboard.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBars } from "@fortawesome/free-solid-svg-icons";
// import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// export default function Objectives() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// const navigate = useNavigate();
//   const handleBack = () => {
//     navigate("/")
//   };
//   return (
//     <div
//       className={styles.homeScreenContainer}
//       style={{
//         height: "100vh",
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* Header */}
//       <div className={styles.homeScreenHeader}>
//         {/* <button
//           onClick={() => setIsSidebarOpen(true)}
//           className={styles.homeScreenMenuBtn}
//         >
//           <FontAwesomeIcon icon={faBars} />
//         </button> */}

//         <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>

        
//         <TownPlanningSidebar
//           isOpen={isSidebarOpen}
//           onClose={() => setIsSidebarOpen(false)}
//         />

//         <h2 style={{ color: "white" }}>Objectives</h2>
//       </div>

//       {/* Scrollable Content Area */}
//       <div
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           padding: "20px",
//           color: "white",
//         }}
//       >
 
//  {/* <p style={{ textAlign: "justify" }}>
//   We welcome you to the amazing and creative world of Town Planning. This app is designed to support town planning officers, citizens, and stakeholders engaged in urban development across Maharashtra. The app serves as a comprehensive resource, offering general and technical information, documents including ACTS, RULES, COURT ORDERS, DIRECTIVES, GR and legal provisions relevant to daily office work. It aims to simplify access to essential documents and guidelines, ensuring efficiency and clarity as well as to bring uniformity in practices for officers in government departments. Beyond administration, the app is equally valuable for civil engineers, architects, urban planners, and academic professionals, fostering informed decision-making and knowledge sharing in the field of sustainable urban development. This is a non-profit initiative to help town planning community and strive to achieve ATMANIRBHAR TOWN PLANNING.
// </p> */}

// <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
//   <li>
//     We welcome you to the amazing and creative world of Town Planning.
//   </li>

//   <li>
//     This app is designed to support town planning practitioners, citizens, and agencies interested in the field of sustainable urban development across Maharashtra State.
//   </li>

//   <li>
//     The app serves as a forum for publicly available resources and relevant documents, offering general and technical information.
//   </li>

//   <li>
//     It aims to simplify access to publicly available documents and guidelines, ensuring efficiency and clarity, as well as to create awareness among the general public by providing a compilation of publicly available information in one place.
//   </li>

//   <li>
//     This app is also valuable for civil engineers, architects, urban planners, and academic professionals, fostering informed decision-making, knowledge sharing, and contributing to the field of sustainable urban development.
//   </li>

//   <li>
//     This is a non-profit initiative dedicated to supporting the town planning community and striving to achieve <strong>ATMANIRBHAR TOWN PLANNING</strong>.
//   </li>
// </ul>


//       </div>
//     </div>
//   );
// }





import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Target, 
  Leaf, 
  Library, 
  Zap, 
  GraduationCap, 
  Flag 
} from "lucide-react";

export default function Objectives() {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button 
            onClick={handleBack} 
            className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">Mission</h2>
        </div>
      </div>

      {/* --- CONTENT AREA --- */}
      <main className="flex-1 max-w-3xl mx-auto px-4 py-10 w-full">
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/30 ring-1 ring-slate-200 overflow-hidden">
          
          {/* Top Decorative Banner */}
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight uppercase">Objectives</h3>
              <p className="text-xs text-slate-400 font-bold tracking-widest mt-1">Our Vision & Goals</p>
            </div>
            <div className="w-12 h-12 bg-orange-600 rounded-2xl flex items-center justify-center shadow-lg shadow-orange-900/20">
              <Target size={24} className="text-white" />
            </div>
          </div>

          <div className="p-8 md:p-12 space-y-10">
            
            {/* Welcome Intro */}
            <div className="text-center space-y-2">
               <h4 className="text-2xl font-black text-slate-900 tracking-tight">
                 Welcome to the creative world of Town Planning.
               </h4>
               <p className="text-slate-500 font-medium italic">Supporting urban development across Maharashtra State.</p>
            </div>

            {/* Objectives Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              
              <div className="space-y-3">
                <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center text-orange-600 border border-orange-100">
                  <Leaf size={20} />
                </div>
                <h5 className="font-black text-slate-900 uppercase text-xs tracking-widest">Sustainability</h5>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Designed to support practitioners and agencies interested in sustainable urban development.
                </p>
              </div>

              <div className="space-y-3">
                <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600 border border-blue-100">
                  <Library size={20} />
                </div>
                <h5 className="font-black text-slate-900 uppercase text-xs tracking-widest">Resource Forum</h5>
                <p className="text-slate-600 text-sm leading-relaxed">
                  A forum for publicly available resources, offering both general and technical information.
                </p>
              </div>

              <div className="space-y-3">
                <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 border border-emerald-100">
                  <Zap size={20} />
                </div>
                <h5 className="font-black text-slate-900 uppercase text-xs tracking-widest">Efficiency</h5>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Simplifying access to guidelines to ensure clarity and efficiency for the general public.
                </p>
              </div>

              <div className="space-y-3">
                <div className="w-10 h-10 rounded-xl bg-purple-50 flex items-center justify-center text-purple-600 border border-purple-100">
                  <GraduationCap size={20} />
                </div>
                <h5 className="font-black text-slate-900 uppercase text-xs tracking-widest">Academic Value</h5>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Empowering architects, engineers, and academic professionals with informed decision-making tools.
                </p>
              </div>

            </div>

            {/* Atmanirbhar Callout */}
            <div className="bg-slate-900 rounded-3xl p-8 flex flex-col items-center text-center space-y-4">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center text-orange-500">
                <Flag size={24} />
              </div>
              <div>
                <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.2em] mb-2">Non-Profit Initiative</p>
                <h4 className="text-white text-xl font-black tracking-tight">
                  Striving to achieve <span className="text-orange-500 underline underline-offset-8">ATMANIRBHAR TOWN PLANNING</span>
                </h4>
              </div>
            </div>

          </div>
        </div>

        <p className="text-center mt-10 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel Intelligence Platform • Pune, Maharashtra
        </p>
      </main>
    </div>
  );
}